import React from "react"
import { throttle } from "./utils"

const useWindowScrollPosition = ({ throttleMs = 100 }) => {
  const [scroll, setScroll] = React.useState({
    x: window.pageXOffset,
    y: window.pageYOffset
  })

  const handle = throttle(() => {
    setScroll({
      x: window.pageXOffset,
      y: window.pageYOffset
    })
  }, throttleMs)

  React.useEffect(() => {
    window.addEventListener("scroll", handle)

    return () => {
      window.removeEventListener("scroll", handle)
    }
  }, [])

  return scroll
}

export default useWindowScrollPosition
